<template>
    <div class="pmContent">
        <PmLeft v-bind="$attrs"  @xyPosFn="xyPosFn" :newInfo="newInfo"/>
        <PmRight ref="xyPosFnRef" v-bind="$attrs" @carrierInfo="carrierInfo" :xy="xy"/>
    </div>
</template>

<script>
import PmLeft from './pm/Pmleft.vue';
import PmRight from './pm/PmRight.vue';
export default {
    components: {
        PmLeft,
        PmRight
    },
    data(){
        return {
            // 选择监测点之后请求回来的数据  这里不用event bus了
            newInfo:{},
            xy:{}
        }
    },
    methods:{
        carrierInfo(obj){
            this.newInfo = {...obj}
        },
        xyPosFn(obj){
            this.xy = {...obj}
            this.$refs.xyPosFnRef.xyPosFn(obj)

        }
    }
}
</script>

<style lang="scss" scoped>
.pmContent {
    height: calc(100% - 50px);
    width: 100%;
    display: flex;
}
</style>